import {
  Engagement,
  PayeeEngagementStatus
} from "@wingspanhq/wingspan-api-sdk";
import { WSPanel } from "@wingspanhq/fe-component-library";
import React from "react";
import { queriesPayeeEngagements } from "@query";
import { DataViewGrid } from "../../../../shared/components/DataView";

// The app's "archive" action is `suspend` (reversible — `terminate` is terminal and
// would strand the restore flow), so both non-live states read as archived here.
const ARCHIVED_STATUSES = [
  PayeeEngagementStatus.SUSPENDED,
  PayeeEngagementStatus.TERMINATED
];

export const ActionEngagementDetails: React.FC<{ engagement: Engagement }> = ({
  engagement
}) => {
  const engagementId = engagement.id;

  // Server-side counts: one row requested, total read off the envelope — the v3
  // twin of v1's `page[size]=1` + `x-ws-list-size` header.
  const queryAllEngagements =
    queriesPayeeEngagements.listPayeeEngagementsByPayer.useQuery({
      filter: { engagementId: { eq: engagementId } },
      page: { size: 1 }
    });

  const queryArchivedEngagements =
    queriesPayeeEngagements.listPayeeEngagementsByPayer.useQuery({
      filter: {
        engagementId: { eq: engagementId },
        status: { anyOf: ARCHIVED_STATUSES }
      },
      page: { size: 1 }
    });

  const allCount = queryAllEngagements.data?.pagination?.totalSize;
  const archivedCount = queryArchivedEngagements.data?.pagination?.totalSize;
  const activeCount =
    allCount === undefined || archivedCount === undefined
      ? undefined
      : allCount - archivedCount;

  return (
    <WSPanel
      shimmer={
        queryAllEngagements.isLoading || queryArchivedEngagements.isLoading
      }
    >
      <DataViewGrid
        gridColumns={2}
        data={[
          {
            label: "Engagement name",
            value: engagement.name
          },
          {
            label: "Assignments with historical data",
            value: allCount
          },
          {
            label: "Active assignments",
            value: activeCount
          },
          {
            label: "Archived assignments",
            value: archivedCount
          }
        ]}
      />
    </WSPanel>
  );
};
